import React, { useState, useEffect } from "react";
import {
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import InputMask from "react-input-mask";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { Link } from "react-router-dom";
import BrandSelect from "../../../../shared/selects/BrandSelect";
import ModelSelect from "../../../../shared/selects/ModelSelect";
import styles from "../../../../../styles/global-styles";
import {
  searchMovileByBarCode,
  getMovilesByFilters,
} from "../../utils.inventory";
import { AuthService } from "../../../../../services/auth.service";
import { ProductService } from "../../../../../services/product.service";

const useStyles = makeStyles((theme) => ({
  title: styles.title,
  rightButton: styles.buttonRightHeader,
  header: styles.header,
  link: styles.link,
}));

const MovileHeader = ({
  moviles,
  title,
  movilesInSite,
  movilesFiltered,
  movileByBarCodeFiltered,
  rowsPerPage,
  loadingProducts,
  movileByImei,
  movileByBarCode,
}) => {
  const classes = useStyles();

  const [queryParams, setqueryParams] = useState({});
  const [barCode, setBarCode] = useState("");
  const [imeiCode, setImeiCode] = useState("");

  useEffect(() => {
    if (movilesInSite && !Object.keys(movileByImei).length) {
      setImeiCode("");
    }
  }, [movileByImei]);

  useEffect(() => {
    if (!movilesInSite && !Object.keys(movileByBarCode).length) {
      setBarCode("");
    }
  }, [movileByBarCode]);

  const handleQuerySelected = (key, value) => {
    if (key === "brand" && queryParams.model) {
      setqueryParams({
        ...queryParams,
        model: "",
        [key]: value === "none" ? "" : value,
      });
    } else
      setqueryParams({ ...queryParams, [key]: value === "none" ? "" : value });
  };

  const handleBarCodeInput = ({ target: { value } }) => setBarCode(value);

  const handleImeiInput = ({ target: { value } }) => setImeiCode(value);

  const searchMovileByFilters = async () => {
    loadingProducts();
    try {
      const body = {
        ...queryParams,
        page: 0,
        limit: rowsPerPage,
      };
      console.log("queryParams", body);
      const { moviles, count } = await getMovilesByFilters(body);
      if (moviles.length) {
        movilesFiltered({ moviles, count, params: queryParams }, true);
      } else {
        movilesFiltered(
          "No se encontró un producto con los filtros seleccionados",
          false
        );
      }
    } catch (error) {
      movilesFiltered(
        error.msgs || "Error al filtar equipos moviles, volver a intentar",
        false
      );
    }
  };

  const searchProductMovileByBarCode = async () => {
    const queryParams = {
      barCode,
      inDistribution: 0,
    };
    try {
      const result = await searchMovileByBarCode(queryParams);
      console.log("result", result);
      movileByBarCodeFiltered(await searchMovileByBarCode(queryParams), true);
    } catch (error) {
      console.log("error findMovileByBarCode", error);
      movileByBarCodeFiltered(error, false);
    }
  };

  const searchProductMovileByImei = async () => {
    const movileNotFound = {
      mssgError: `No se encontró equipo móvil asociado al IMEI ${
        imeiCode || ""
      }`,
    };
    try {
      const { siteId } = AuthService.currentUserValue;
      const queryParams = {
        imeiCode,
        siteId,
      };
      console.log("queryParams", queryParams);
      const { data } = await ProductService.getProductMovile(queryParams);
      if (data) movilesFiltered(data, true);
      else throw movileNotFound;
    } catch (error) {
      movilesFiltered(error, false);
    }
  };
  return (
    <>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item>
          <Typography variant="h4" component="h4" className={classes.title}>
            {title}
          </Typography>
        </Grid>
        {moviles && moviles.length > 0 && !movilesInSite && (
          <>
            <Grid item>
              <BrandSelect brand={handleQuerySelected} isMovile />
            </Grid>
            {queryParams.brand && (
              <Grid item>
                <ModelSelect
                  brand={queryParams.brand}
                  model={handleQuerySelected}
                  isMovile
                />
              </Grid>
            )}

            <Grid item>
              <Button
                className={classes.rightButton}
                variant="contained"
                onClick={searchMovileByFilters}
                color="primary"
                endIcon={<SearchIcon color="secondary" />}
              >
                Filtrar
              </Button>
            </Grid>
          </>
        )}

        {movilesInSite && moviles?.length > 0 && (
          <>
            <Grid item>
              <Typography className={classes.header}>
                Búsqueda por Imei
              </Typography>
            </Grid>
            <Grid item>
              <InputMask
                mask="999999999999999"
                maskChar=""
                value={imeiCode || ""}
                onChange={(e) => handleImeiInput(e)}
              >
                {() => (
                  <TextField
                    name="imeiCode"
                    placeholder="Imei"
                    variant="outlined"
                  />
                )}
              </InputMask>
            </Grid>
            <Grid item>
              <Button
                className={classes.rightButton}
                disabled={imeiCode.length === 0}
                variant="contained"
                onClick={searchProductMovileByImei}
                color="primary"
                endIcon={<SearchIcon color="secondary"></SearchIcon>}
              >
                Buscar
              </Button>
            </Grid>
          </>
        )}
      </Grid>

      {/** Search by code bar */}
      {!movilesInSite && (
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          spacing={4}
          style={{ marginTop: 10 }}
        >
          {moviles?.length > 0 && (
            <>
              <Grid item>
                <Typography className={classes.header}>
                  Búscar código de barras
                </Typography>
              </Grid>
              <Grid item>
                <InputMask
                  mask="99999999999999999999"
                  maskChar=""
                  value={barCode || ""}
                  onChange={(e) => handleBarCodeInput(e)}
                >
                  {() => (
                    <TextField
                      className={classes.inputField}
                      name="barCode"
                      placeholder="Código de barras"
                      variant="outlined"
                    />
                  )}
                </InputMask>
              </Grid>
              <Grid item>
                <Button
                  className={classes.rightButton}
                  variant="contained"
                  disabled={barCode.length === 0}
                  onClick={searchProductMovileByBarCode}
                  color="primary"
                  endIcon={<SearchIcon color="secondary"></SearchIcon>}
                >
                  Buscar
                </Button>
              </Grid>
              <Grid item xs={3}></Grid>
            </>
          )}
          <Grid item>
            <Link
              to={{
                pathname: `../inventario/captura`,
                state: { tabOption: 1 },
              }}
              className={classes.link}
            >
              <Button
                className={classes.rightButton}
                variant="contained"
                color="primary"
                endIcon={<AddCircleIcon color="secondary"></AddCircleIcon>}
              >
                Agregar inventario
              </Button>
            </Link>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default MovileHeader;
